import { useState } from 'react'
import EchoModal from '@/components/EchoModal'
import { Space, Input, Message, Button, Modal, Image } from '@arco-design/web-react'
import { IconInfoCircle } from '@arco-design/web-react/icon'
import useLocale from '@/utils/useLocale'
import { SUCCESS_CODE } from '@/utils/constants'
import { getManualRecordProductApi, getManualRecordShopApi } from '@/api/common'
import { useIsZh } from '@/hooks/useIsZh'

interface Props {
  visible: boolean
  onCancel: () => void
  successCallback?: (data: any) => void
  type: 'product' | 'shop'
}

export default function ManualRecordModal({ visible, onCancel, successCallback, type }: Props) {
  const t = useLocale()
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [shareUrl, setShareUrl] = useState('')
  const [isShowGuide, setIsShowGuide] = useState(false)
  const isZh = useIsZh()

  const srcList = isZh
    ? ['https://static.echotik.live/assets/record.webp']
    : ['https://static.echotik.live/assets/record_en.webp']

  const handleConfirm = async () => {
    try {
      setConfirmLoading(true)
      const res =
        type === 'product' ? await getManualRecordProductApi(shareUrl) : await getManualRecordShopApi(shareUrl)
      if (res.data.code === SUCCESS_CODE) {
        Message.success(t['manual_record_success'])
        onCancel?.()
        successCallback?.(res.data.data)
      }
      setConfirmLoading(false)
    } catch (error) {
      Message.error(t['manual_record_fail'])
    }
  }
  return (
    <EchoModal
      isAutoContent
      confirmLoading={confirmLoading}
      visible={visible}
      onCancel={() => onCancel?.()}
      footer={
        <div className="flex justify-between items-center">
          <span className="text-primary cursor-pointer" onClick={() => setIsShowGuide(true)}>
            {t['use_guide']}
          </span>
          <Space>
            <Button className="rounded-xl" onClick={() => onCancel?.()}>
              {t['modal.cancel']}
            </Button>
            <Button type="primary" className="rounded-xl" onClick={handleConfirm}>
              {t['common.list.ok']}
            </Button>
          </Space>
        </div>
      }
      title={type === 'product' ? t['manual_record_product'] : t['manual_record_shop']}
    >
      <Space>
        <IconInfoCircle />
        <span>{type === 'product' ? t['manual_record_product_tips'] : t['manual_record_shop_tips']}:</span>
        <Input
          value={shareUrl}
          onChange={(val) => setShareUrl(val)}
          placeholder={
            type === 'product' ? t['manual_record_product_placeholder'] : t['manual_record_shop_placeholder']
          }
          style={{ minWidth: 294 }}
        />
      </Space>
      <Image.PreviewGroup srcList={srcList} visible={isShowGuide} onVisibleChange={setIsShowGuide} />
    </EchoModal>
  )
}
